import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'cre-ng';

import { AppDataService } from '@app/core/app-data.service';
import { W4Service } from '@app/services/implementation/employee.service';
import { IEmployeeService } from '@app/services/interface/IEmployeeService';
import { MockW4Service } from '@app/services/mock/employee.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceFactory{

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private appDataService: AppDataService
  ) { }

  public getEmployeeService(): IEmployeeService {

    if (window.__env.ngSettings.mock) {
      return new MockW4Service();
    } else {
      return new W4Service(this.httpClient, this.authService, this.appDataService);
    }
  }
}
